'use client';
import { Box } from '@skin-seoul/design-system';

import { CampaignSectionSubTitle, CampaignSectionTitle } from '../components/CampaignSectionHeader';
import ViewAllButton from '../components/ViewAllButton';

import HiddenGemProductList from './HiddenGemProductList';
import SectionHeader from '../components/SectionHeader';
import QueryBoundary from '../../utils/react/QueryBoundary';
import { ProductGrid, ProductGridSkeleton } from '../components/ProductGrid';
import SectionContainer from '../components/SectionContainer';

export const HiddenGemSection = () => {
  const handleViewAll = () => {
    if (typeof window !== 'undefined') {
      window.location.href = '/campaign/ggu-hidden-gem/';
    }
  };

  return (
    <SectionContainer
      containerInnerProps={{
        transform: 'scale(1.0001)',
        backgroundColor: 'white',
        alignItems: 'center',
        gap: '48px',
      }}
    >
      <Box
        display={{ base: 'none', desktop: 'flex' }}
        width="100%"
        flexDirection="column"
        alignItems="flex-end"
        margin={0}
        justifyContent="flex-start"
        gap="12px"
      >
        <CampaignSectionTitle theme="light">Our Hidden Gems</CampaignSectionTitle>
        <CampaignSectionSubTitle theme="light">Handpicked From Our Glow Vault</CampaignSectionSubTitle>
      </Box>
      <SectionHeader
        theme="light"
        title="Our Hidden Gems"
        subtitle="Handpicked From Our Glow Vault"
        display={{ base: 'flex', desktop: 'none' }}
        href={handleViewAll}
      />
      <QueryBoundary clientOnly loadingFallback={<ProductGridSkeleton length={5} />}>
        <ProductGrid>
          <HiddenGemProductList />
        </ProductGrid>
      </QueryBoundary>

      <ViewAllButton onClick={handleViewAll} theme="light" />
    </SectionContainer>
  );
};
